export function formatAppointmentDate(date: string, time: string) {
    const aptDate = new Date(date.replace(/-/g, "/")).toLocaleDateString("en-US");
  
    var timeChosen: string | string[] = time;
  
    timeChosen = timeChosen.split(":"); // convert to array
  
    var hours = Number(timeChosen[0]);
    var minutes = Number(timeChosen[1]);
  
    var timeValue = '';
  
    if (hours > 0 && hours <= 12) {
      timeValue = "" + hours;
    } else if (hours > 12) {
      timeValue = "" + (hours - 12);
    } else if (hours === 0) {
      timeValue = "12";
    }
  
    timeValue += minutes < 10 ? ":0" + minutes : ":" + minutes; // get minutes
    timeValue += hours >= 12 ? " P.M." : " A.M."; // get AM/PM
  
    return `${aptDate} ${timeValue}`;
  }